import { Notifications } from "@mantine/notifications";
import { Outlet } from "react-router-dom";

import { NOTIFICATIONS_STACK_STYLE } from "#app/notifications";
import { ThemeProviderV2 } from "#app/theme/v2/ThemeProviderV2";

export const OnboardingV2Layout = () => (
  <ThemeProviderV2>
    <Notifications position="bottom-right" style={NOTIFICATIONS_STACK_STYLE} />
    <Outlet />
  </ThemeProviderV2>
);
